import {
    PM_SESSION_START,
    PM_SESSION_ACCEPTED,
    PM_ACCESS_REQUEST,
    PM_ACCESS_CHANGE_ALLOWED,
    PM_MESSAGE,
    PM_HISTORY,
    PM_USER_UPDATE
} from '../constants/pm';

import {
    VIDEO_WINDOW_OPEN
} from '../constants/streaming';

const userMiddleware = (store) => (next) => (action) => {
    let ufrag;
    let uid;
    switch(action.type) {
        case VIDEO_WINDOW_OPEN: ufrag = action.ufrag; break;
    }

    if (ufrag || uid) {
        let state = store.getState();

        let user = null;
        if (ufrag) user = state.users.get({ufrag});
        if (uid) user = state.users.get({uid});

        if (!user) {
            if (state.pm.conversations[uid]) {

                user = state.pm.conversations[uid].user;
            }
        }
        if (user) {
            next({ ...action, user });
        }
    } else {
        next(action);
    }
};

export default userMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/user.js